import { Td, Tr } from '@chakra-ui/react'
import { ConfirmePagamento } from './ConfirmePagamento'
import { formatPrice } from '../../../utils/formatPrice'
import { cnpjMask } from '../../../utils/cnpjMask'

export function Pagamento({
  numero_innovation,
  numero_unico,
  empresa_razao_social,
  empresa_cnpj,
  cliente_razao_social,
  cliente_cnpj,
  valor_total,
}) {
  return (
    <Tr key={numero_unico}>
      <Td>{numero_unico}</Td>
      <Td>{numero_innovation}</Td>
      <Td textTransform="capitalize">{empresa_razao_social.toLowerCase()}</Td>
      <Td>{cnpjMask(empresa_cnpj)}</Td>
      <Td textTransform="capitalize">{cliente_razao_social.toLowerCase()}</Td>
      <Td>{cnpjMask(cliente_cnpj)}</Td>
      <Td>{formatPrice(valor_total)}</Td>
      <Td>
        <ConfirmePagamento numero_unico={numero_unico} />
      </Td>
    </Tr>
  )
}
